// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3N4Y0","footer":"ChangeClinic_footer__3b2zF"};